"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDayOfMonth = exports.SelectDayOfWeek = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const interfaces_1 = require("../interfaces");
const TextField_1 = require("./forms/TextField");
exports.SelectDayOfWeek = (props) => {
    const { value, handleDayOfWeekChange } = props;
    return (react_1.default.createElement("div", { style: { display: 'flex', marginTop: '20px' } }, interfaces_1.DAYS_OF_WEEK.map(item => {
        return (react_1.default.createElement("div", { style: { marginLeft: '5px', alignItems: 'center' } },
            react_1.default.createElement(material_1.InputLabel, null, item.substring(0, 3)),
            react_1.default.createElement(material_1.Checkbox, { key: item, onChange: (event) => {
                    handleDayOfWeekChange(event.target.checked, item);
                }, checked: value.includes(item) })));
    })));
};
exports.SelectDayOfMonth = (props) => {
    const { day, handleDayOfMonthChange } = props;
    react_1.useEffect(() => { }, [day]);
    return (react_1.default.createElement(TextField_1.TextField, { type: "text", value: day, onChange: event => {
            const { value } = event.target;
            handleDayOfMonthChange(parseInt(value, 10));
        }, label: "Select day of the month", inputProps: {
            max: 31,
            min: 0,
        } }));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2F2ZWRTZWFyY2hNb2RhbENvbnRlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TYXZlZFNlYXJjaE1vZGFsQ29udGVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVILCtDQUF5QztBQUN6Qyw0Q0FBcUQ7QUFHckQsOENBQTZDO0FBQzdDLGlEQUE4QztBQUdqQyxRQUFBLGVBQWUsR0FBRyxDQUFDLEtBRy9CLEVBQUUsRUFBRTtJQUNILE1BQU0sRUFBRSxLQUFLLEVBQUUscUJBQXFCLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFDL0MsT0FBTyxDQUNMLHVDQUFLLEtBQUssRUFBRSxFQUFFLE9BQU8sRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLE1BQU0sRUFBRSxJQUMvQyx5QkFBWSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsRUFBRTtRQUN2QixPQUFPLENBQ0wsdUNBQUssS0FBSyxFQUFFLEVBQUUsVUFBVSxFQUFFLEtBQUssRUFBRSxVQUFVLEVBQUUsUUFBUSxFQUFFO1lBQ3JELDhCQUFDLHFCQUFVLFFBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQWM7WUFDL0MsOEJBQUMsbUJBQVEsSUFDUCxHQUFHLEVBQUUsSUFBSSxFQUNULFFBQVEsRUFBRSxDQUFDLEtBQTBDLEVBQUUsRUFBRTtvQkFDdkQscUJBQXFCLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLENBQUM7Z0JBQ3BELENBQUMsRUFDRCxPQUFPLEVBQUUsS0FBSyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsR0FDN0IsQ0FDRSxDQUNQLENBQUM7SUFDSixDQUFDLENBQUMsQ0FDRSxDQUNQLENBQUM7QUFDSixDQUFDLENBQUM7QUFFVyxRQUFBLGdCQUFnQixHQUFHLENBQUMsS0FBNkIsRUFBRSxFQUFFO0lBQ2hFLE1BQU0sRUFBRSxHQUFHLEVBQUUsc0JBQXNCLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFDOUMsaUJBQVMsQ0FBQyxHQUFHLEVBQUUsR0FBRSxDQUFDLEVBQUUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO0lBQzNCLE9BQU8sQ0FDTCw4QkFBQyxxQkFBUyxJQUNSLElBQUksRUFBQyxNQUFNLEVBQ1gsS0FBSyxFQUFFLEdBQUcsRUFDVixRQUFRLEVBQUUsS0FBSyxDQUFDLEVBQUU7WUFDaEIsTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUM7WUFDL0Isc0JBQXNCLENBQUMsUUFBUSxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO1FBQzlDLENBQUMsRUFDRCxLQUFLLEVBQUMseUJBQXlCLEVBQy9CLFVBQVUsRUFBRTtZQUNWLEdBQUcsRUFBRSxFQUFFO1lBQ1AsR0FBRyxFQUFFLENBQUM7U0FDUCxHQUNELENBQ0gsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9